export default class NoScroll {
    noScroll(boolean) {
        document.body.style.overflow = boolean ? 'hidden' : '';
        // document.getElementById('root').scrolling = boolean ? 'no' : '';
    }
}